var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJsFunction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#858282",
    d: "M0 11.6667V10.8227H1.21754C1.6746 10.8227 2.02923 10.6977 2.2814 10.4476C2.53358 10.1976 2.65967 9.84591 2.65967 9.39267V4.65714H0.744707V3.81319H2.65967V2.58242C2.65967 2.0823 2.81334 1.69548 3.12067 1.42198C3.42801 1.14066 3.8575 1 4.40914 1H6.28863V1.83223H4.40914C3.87326 1.83223 3.60533 2.0862 3.60533 2.59414V3.81319H6.28863V4.65714H3.60533V9.42784C3.60533 10.1077 3.38861 10.6508 2.95518 11.0571C2.52176 11.4635 1.94254 11.6667 1.21754 11.6667H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#858282",
    d: "M6.32604 9.55678L8.59563 6.23956L6.46789 3.10989H7.57904L8.90297 5.19634C8.98965 5.337 9.08028 5.5011 9.17484 5.68864C9.26941 5.5011 9.36003 5.337 9.44672 5.19634L10.7706 3.10989H11.87L9.74224 6.25128L12 9.55678H10.8888L9.47036 7.35311C9.38368 7.21245 9.28517 7.03272 9.17484 6.81392L8.85568 7.35311L7.42537 9.55678H6.32604Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsFunction);
export default __webpack_public_path__ + "static/media/js-function.d21a58701053fee0933bb89a83b5972d.svg";
export { ForwardRef as ReactComponent };